import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { Wallet, Shield, AlertCircle } from 'lucide-react';
import { Button } from '../components/ui/button';
import { Card, CardContent } from '../components/ui/card';

function AuthPage() {
  const { loginWithGoogle } = useAuth();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleGoogleLogin = async () => {
    setError('');
    setLoading(true);
    try {
      await loginWithGoogle();
    } catch (err) {
      console.error('Auth error:', err);
      setError('Erro ao conectar com Google. Tente novamente.');
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#FDFBF7] flex flex-col">
      {/* Header */}
      <header className="bg-[#1B2A4A] text-white py-6 px-6">
        <div className="max-w-md mx-auto text-center">
          <Link to="/" className="inline-flex items-center gap-3 text-white no-underline">
            <div className="w-12 h-12 bg-white rounded-xl flex items-center justify-center">
              <Wallet className="w-7 h-7 text-[#1B2A4A]" />
            </div>
            <h1 className="text-2xl font-bold text-white">Bolso Sob Controle</h1>
          </Link>
        </div>
      </header>

      {/* Main Content */}
      <main className="flex-1 flex items-center justify-center px-4 py-8">
        <Card className="w-full max-w-md border-2 border-slate-200 shadow-xl" data-testid="auth-card">
          <CardContent className="pt-8 pb-8 text-center space-y-6">
            <div className="w-16 h-16 bg-[#1B2A4A] rounded-2xl flex items-center justify-center mx-auto">
              <Wallet className="w-8 h-8 text-white" />
            </div>

            <h2 className="text-2xl font-bold text-[#1B2A4A]">
              Entre com sua conta Google para começar
            </h2>

            {error && (
              <div className="flex items-center gap-3 p-4 bg-red-50 border-2 border-red-200 rounded-xl text-red-700 text-left" data-testid="auth-error">
                <AlertCircle size={24} className="flex-shrink-0" />
                <span className="font-medium">{error}</span>
              </div>
            )}

            <Button
              type="button"
              variant="outline"
              onClick={handleGoogleLogin}
              disabled={loading}
              className="w-full h-16 text-lg font-semibold border-2 border-slate-300 rounded-xl bg-white text-[#1B2A4A] hover:bg-slate-50 hover:text-[#1B2A4A]"
              data-testid="google-login-btn"
            >
              {loading ? (
                <span className="flex items-center gap-2">
                  <span className="animate-spin rounded-full h-5 w-5 border-2 border-[#1B2A4A] border-t-transparent"></span>
                  Conectando...
                </span>
              ) : (
                <>
                  <svg className="w-6 h-6 mr-3" viewBox="0 0 24 24">
                    <path d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92a5.06 5.06 0 0 1-2.2 3.32v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.1z" fill="#4285F4"/>
                    <path d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" fill="#34A853"/>
                    <path d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z" fill="#FBBC05"/>
                    <path d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" fill="#EA4335"/>
                  </svg>
                  Entrar com Google
                </>
              )}
            </Button>

            <p className="text-base text-slate-500">
              Gratuito para sempre. Sem cartão de crédito.
            </p>
          </CardContent>
        </Card>
      </main>

      {/* Footer */}
      <footer className="py-4 text-center text-slate-500">
        <div className="flex items-center justify-center gap-2">
          <Shield size={18} />
          <span className="text-sm">Seus dados estão protegidos</span>
        </div>
      </footer>
    </div>
  );
}

export default AuthPage;
